// extracted by mini-css-extract-plugin
export default {"boxFirst":"error-bundary_boxFirst__oT+4t","containerButtonModal":"error-bundary_containerButtonModal__f13lw","body":"error-bundary_body__4YdEL"};